import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { GraphQLClient, gql } from 'graphql-request';

const API_URL =
  'https://api-us-east-1-shared-usea1-02.hygraph.com/v2/clr51oihbu28g01uqa6kxm4x7/master';

type FAQ = {
  question: string;
  answer: string;
  location: 'nyc' | 'brooklyn' | 'manhattan' | 'queens';
};

type Review = {
  avatar: {
    size: number;
    url: string;
  };
  review: {
    text: string;
    markdown: string;
  };
  source: string;
  username: string;
}

const graphqlClient = new GraphQLClient(API_URL);

export function useFAQs(location: FAQ['location']): UseQueryResult<FAQ[]> {
  const document = gql`
    query {
        fAQs(where: {location: ${location}}) {
            question
            answer {
                markdown
            }
            location
            id
        }
    }
`;

  return useQuery({
    queryKey: ["faqs", location],
    queryFn: async () => {
      const data: any = await graphqlClient.request(document as any);
      return data.fAQs;
    },
  })
}

export function useReviews(): UseQueryResult<Review[]>  {
  const document = gql`
    query {
      reviews {
        avatar {
          size
          url(transformation: {image: {resize: {height: 40, width: 40}}})
        }
        review {
          markdown
        }
        source
        username
      }
    }
  `;

  return useQuery({
    queryKey: ["reviews"],
    queryFn: async () => {
      const data: any = await graphqlClient.request(document as any);
      return data.reviews;
    },
  })
}
